export const INPUT_MIN_ROWS = 1;
export const INPUT_MAX_ROWS = 6;

export const SEND_BUTTON_TOOLTIP = 'Send';
export const STOP_BUTTON_TOOLTIP = 'Stop generating';
